import React from 'react';
import { ThemedLink } from '@helpcenter/themed-link';
import errorImg from 'assets/images/search-modal-error.svg';
import { useIntl } from 'react-intl';
import Heading from '@atlaskit/heading';
import { Stack } from '@atlaskit/primitives';
import { getHelpCenterUrl } from '@atlassian/help-center-common-util/url';
import { Img } from '../common';
import messages from './messages';

const SearchResultError = () => {
    const { formatMessage } = useIntl();

    return (
        <Stack alignInline="center">
            <Img src={errorImg} />
            <Heading size="xsmall">{formatMessage(messages.searchErrorTitle)}</Heading>
            {/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop,@atlaskit/design-system/use-primitives-text -- Disabled to rollout go/ui-styling-standard tooling, please resolve */}
            <p style={{ textAlign: 'center' }}>
                {formatMessage(messages.searchErrorText, {
                    helpCenterLink: (
                        <ThemedLink to={getHelpCenterUrl()} actionSubjectId="helpCenterLink">
                            {formatMessage(messages.helpCenter)}
                        </ThemedLink>
                    ),
                })}
            </p>
        </Stack>
    );
};

export default SearchResultError;
